export const Skeleton = ({
  count = 10,
  rows = 3,
  minHeight = 126,
}: {
  count?: number;
  rows?: number;
  minHeight?: number;
}): React.JSX.Element => {
  const skeletonClassName = {
    holder: 'flex flex-col gap-3',
    item: 'pks-card-bg overflow-hidden rounded-lg',
    itemContent:
      'pks-layout-col justify-center bg-white ml-[6px] pl-[22px] pr-4 py-3',
  };

  const skeletonItems = Array.from({ length: count }, (_, index) => (
    <li key={index} className={`${skeletonClassName.item} animate-pulse`}>
      <div
        className={`${skeletonClassName.itemContent} space-y-2`}
        style={{
          minHeight: minHeight,
        }}
      >
        {Array.from({ length: rows }, (_, i) => (
          <p
            key={i}
            className="h-4 bg-gray-300 rounded"
            style={{
              width: `${Math.random() * 50 + 50}%`, // Random width between 50% and 100%
            }}
          ></p>
        ))}
      </div>
    </li>
  ));

  return <ul className={skeletonClassName.holder}>{skeletonItems}</ul>;
};
